// React and related imports
import React, { useState } from 'react';

// Flowbite components
import { Navbar } from 'flowbite-react';

// Component imports
import { Logo } from '../Logo/Logo';
import { UserDropdown } from './UserDropdown';
import { LanguageSwitcher } from './LanguageSwitcher';
import { DarkModeToggle } from './DarkModeToggle';

// Redux selectors, hooks, and actions
import { HiOutlineMenu } from 'react-icons/hi';
import { toggleSidebar } from '../../redux/slices/displaySettingsSlice';
import { useAppDispatch } from '../../redux/hooks/useAppDispatch';
import { addToast } from '../../redux/slices/toastSlice';
import { persistor } from '../../redux/store';

// i18n
import { useTranslation } from 'react-i18next';

// Auth
import { signOut } from '../../auth/signOut';

// User Info Context
import { useUserInfo } from '../../auth/UserInfoProvider';

export const Header: React.FC = () => {
  const dispatch = useAppDispatch();
  const { userInfo, loadingUserInfo } = useUserInfo();
  const { t } = useTranslation();
  const [signingOut, setSigningOut] = useState(false);

  const handleSignOut = async () => {
    if (signingOut) return;
    setSigningOut(true);
    try {
      await signOut({
        dispatch,
        flush: () => persistor.flush(),
        redirect: (path) => window.location.replace(path),
      });
    } catch {
      setSigningOut(false);
      dispatch(
        addToast({
          message: t('header.userDropdown.signOutFailed'),
          type: 'error',
        })
      );
    }
  };

  return (
    <div className="border-b border-primary-100 border-opacity-20 bg-white">
      <Navbar fluid className="w-full bg-white">
        <Navbar.Brand className="text-black dark:text-white">
          <button
            className="rounded p-2 text-black transition-colors hover:scale-125 hover:bg-primary-600 active:bg-primary-500 dark:text-primary-25 dark:hover:bg-primary-800 dark:active:bg-primary-800 lg:hidden"
            onClick={() => dispatch(toggleSidebar())}
          >
            <HiOutlineMenu />
          </button>
          <Logo />
        </Navbar.Brand>
        <div className="flex items-center justify-center gap-3 text-black dark:text-primary-25 md:order-2">
          <DarkModeToggle />
          <LanguageSwitcher />
          {!loadingUserInfo && userInfo && (
            <UserDropdown
              username={userInfo?.name}
              email={userInfo?.email}
              onSignOut={handleSignOut}
              signingOut={signingOut}
            />
          )}
        </div>
      </Navbar>
    </div>
  );
};
